const resourcePaginate = document.querySelector('[data-paginate]');
if (resourcePaginate) {
  if (resourcePaginate.dataset.type === 'click') resourcePaginate.addEventListener('click', paginateByClick);
  if (resourcePaginate.dataset.type === 'scroll') paginateByScroll(resourcePaginate);
}

async function paginateByClick(event) {
  event.preventDefault();
  const trigger = this;
  trigger.disabled = true;
  trigger.classList.add('cursor-wait');
  const triggerParent = document.querySelector(trigger.dataset.parentElement)
    ? document.querySelector(trigger.dataset.parentElement)
    : trigger.parentElement;
  const insertMethod = trigger.dataset.hasOwnProperty('insertMethod') ? trigger.dataset.insertMethod : 'append';
  const page = await paginateResource(trigger, insertMethod, triggerParent);
  trigger.blur();
  trigger.disabled = false;
  trigger.classList.remove('cursor-wait');
  if (!page || !page.next) triggerParent.parentElement.removeChild(triggerParent);
}

function paginateByScroll(trigger) {
  const observerOptions = {
    threshold: 1,
  };
  const observer = new IntersectionObserver((entries, thisObserver) => {
    entries.forEach(async function (entry) {
      if (!entry.isIntersecting) return;
      const target = entry.target;
      const triggerParent = document.querySelector(trigger.dataset.parentElement)
        ? document.querySelector(trigger.dataset.parentElement)
        : trigger.parentElement;
      const insertMethod = trigger.dataset.hasOwnProperty('insertMethod') ? trigger.dataset.insertMethod : 'append';
      const page = await paginateResource(target, insertMethod, triggerParent);
      if (!page || !page.next) {
        target.parentElement.removeChild(target);
        thisObserver.unobserve(target);
      }
    });
  }, observerOptions);

  observer.observe(trigger);
}

async function paginateResource(trigger, insertMethod, beforeElement = null) {
  if (trigger.dataset.paginate === '') return false;
  const url = trigger.dataset.paginate + '&section_id=' + trigger.dataset.section;
  const page = await fetchNextPage(url);
  if (!page || !page.items) return false;

  const itemList = document.querySelector(trigger.dataset.listSelector);
  const allCurrencyOutputs = [];
  page.items.forEach((item) => {
    if (insertMethod === 'append') itemList.appendChild(item);
    if (insertMethod === 'insertBefore' && beforeElement) itemList.insertBefore(item, beforeElement);
    const currencyOutputs = item.querySelectorAll('[data-money]');
    if (currencyOutputs && currencyOutputs.length) currencyOutputs.forEach((output) => allCurrencyOutputs.push(output));
    /* if (trigger.dataset.paginate.includes('collections')) modifyPaginatedItem(item, 'collection');
    if (trigger.dataset.paginate.includes('/pages/archive')) modifyPaginatedItem(item, 'archive'); */
  });
  trigger.dataset.paginate = page.next ? page.next : '';
  if (allCurrencyOutputs.length) {
    document.body.dispatchEvent(
      new CustomEvent('CurrencyConverterUpdate', {
        detail: { outputs: allCurrencyOutputs },
      })
    );
  }

  return page;
}

async function fetchNextPage(url) {
  const promise = await attemptFetch('resource pagination', url);
  if (!promise) return false;
  const data = await promise.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, 'text/html');
  const items = doc.querySelectorAll('[data-pagination-item]');
  const paginate = doc.querySelector('[data-paginate]');
  const page = {
    items: items && items.length ? items : false,
    next: paginate ? paginate.dataset.paginate : false,
  };
  return page;
}

function modifyPaginatedItem(item, type) {
  switch (type) {
    case 'collection':
      modifyCollectionItem(item);
      break;
    case 'archive':
      modifyArchiveItem(item);
    default:
      break;
  }
}

function modifyCollectionItem(item) {
  const backgroundClasses = ['lg:bg-green', 'lg:bg-navy', 'lg:bg-yellow'];
  const randomIndex = Math.floor(Math.random() * backgroundClasses.length);
  const randomClass = backgroundClasses[randomIndex];
  const backgroundElement = item.querySelector('.bg-random');

  backgroundElement.classList.add(randomClass);

  if (backgroundElement.classList.contains('lg:bg-green') || backgroundElement.classList.contains('lg:bg-navy')) {
    backgroundElement.classList.add(
      'lg:[&_*]:text-beige',
      'lg:[&_input]:!border-beige',
      'lg:[&_input:checked]:bg-beige/30',
      'lg:[&_input:disabled]:before:!border-t-beige'
    );
  }

  const variantSelector = item.querySelector('select[data-variants]');
  initVariantSelector(variantSelector);
  variantSelector.parentElement.removeChild(variantSelector);

  const addToCartForm = item.querySelector('[data-add_to_cart_drawer]');
  handleAddToCartDrawer(addToCartForm);
}

function modifyArchiveItem(item) {
  const positionClasses = [
    'left-[0%]',
    'left-[5%]',
    'left-[10%]',
    'left-[15%]',
    'left-[20%]',
    'left-[25%]',
    'right-[0%]',
    'right-[5%]',
    'right-[10%]',
    'right-[15%]',
    'right-[20%]',
    'right-[25%]',
  ];
  const imageElement = item.querySelector('.archive-img');
  const randomIndex = Math.floor(Math.random() * positionClasses.length);
  const randomClass = positionClasses[randomIndex];
  imageElement.classList.add(randomClass);
}
